export enum FileTypes {
    EmployeeBulkImport = 1,
}